import request from '@/utils/http';

export const getBillLists = (params) => {
    return request({
        url: `/api-bms-web/efapBill/checkTheBill`,
        method: 'get',
        params
    });
};

export const getMdnList = (params) => {
    return request({
        url: `/api-mdm/mdmDataDictionaryDetails?dictCode=SRM_BMS_TASK_TYPE`,
        method: 'get',
        params
    });
};

export const batchSettlement = (data) => {
    return request({
        url: `/api-bms-web/efapBill/submitPaymentHandler`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    });
};
export const checkPaymentHandler = (data) => {
    return request({
        url: `/api-bms-web/efapBill/checkPaymentHandler`,
        method: 'post',
        isBypassErrHandling: true,
        data
    });
};

// 更新付款申请智汇票开票标识接口
export const updateApApplyEisInvoicing = (data) => {
    return request({
        url: '/api-bms-web/eis/updateApApplyEisInvoicing',
        method: 'post',
        data
    });
};